import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12ce67f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "md-input-wrapper" }
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = {
  key: 0,
  class: "error"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "error", -1))
const _hoisted_5 = {
  key: 1,
  class: "error-placeholder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["md-input md-input-field md-content-editable", [
        _ctx.variant,
        _ctx.icon ? 'icon' : '',
        _ctx.hasValue ? 'has-value' : '',
        _ctx.errorMessage ? 'has-error' : '',
        _ctx.border ? '' : 'no-border',
      ]])
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["label", { icon: _ctx.icon }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.focusIn && _ctx.focusIn(...args)))
      }, _toDisplayString(_ctx.label), 3),
      (_ctx.icon)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: "icon material-icons-outlined",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.focusIn && _ctx.focusIn(...args)))
          }, _toDisplayString(_ctx.icon), 1))
        : _createCommentVNode("", true),
      _createElementVNode("p", _mergeProps({
        contenteditable: "true",
        style: { 'min-height': 32 + (_ctx.rows - 1) * 24 + 'px' }
      }, { required: _ctx.required, disabled: _ctx.disabled, id: _ctx.id }, {
        onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
        onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
        onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
        onKeydown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onKeydown && _ctx.onKeydown(...args))),
        onPaste: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onPaste && _ctx.onPaste(...args))),
        ref: "input",
        placeholder: _ctx.placeholder,
        class: [_ctx.align]
      }), null, 16, _hoisted_2),
      (_ctx.variant === 'filled')
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["bottom-line", [_ctx.hasValue || _ctx.focused ? 'active' : '']])
          }, null, 2))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.errorMessage || _ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", null, _toDisplayString(_ctx.errorMessage || _ctx.error), 1)
        ]))
      : (_ctx.error !== false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5))
        : _createCommentVNode("", true)
  ]))
}